/**
 * Shared animation constants for modern-results components
 *
 * Centralizes spring configs and style constants used across
 * AnimatedScoreNumber, ProgressRing, and ModernScoreCard.
 */

import { StyleSheet } from 'react-native';

/**
 * Default spring configuration for score-related animations.
 * Used by AnimatedScoreNumber (counter) and ProgressRing (ring fill).
 */
export const SCORE_SPRING_CONFIG = {
  damping: 15,
  stiffness: 120,
  mass: 1,
} as const;

/**
 * Shared score display styles.
 * The large 72px score text used by both AnimatedScoreNumber and ModernScoreCard.
 */
export const scoreDisplayStyles = StyleSheet.create({
  scoreText: {
    fontSize: 72,
  },
});
